import { scaleLinear } from 'd3-scale';

import { ARC_END_ANGLE, ARC_START_ANGLE } from '../constants.js';

/**
 * Calculates the angle in radians for a given value within a specified range.
 *
 * @param value - The current value to evaluate.
 * @param max - The maximum value of the range.
 * @param min - The minimum value of the range.
 * @returns The calculated angle in radians.
 */
export const calculateGaugeAngle = (
  value: number,
  max: number,
  min: number,
): number => {
  const scale = scaleLinear()
    .domain([min, max])
    .range([ARC_START_ANGLE, ARC_END_ANGLE])
    .clamp(true);

  return scale(value);
};
